import { useMutation } from "react-query";
import { getInvoiceBy } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useSearchSubmitted = () => {
  return useMutation(getInvoiceBy);
};
export default useSearchSubmitted;
